import { createContext, ReactNode, useContext } from "react";
import { ContextType, DataProvider } from "./DataProvider";
import { PropStrength } from "../shared/types/PropStrength";

const PropStrengthDataContext =
  createContext<ContextType<PropStrength> | null>(null);

export const PropStrengthDataProvider = ({
  children,
  cacheKey,
}: {
  children: ReactNode;
  cacheKey?: string;
}) => (
  <DataProvider
    context={PropStrengthDataContext}
    collection="propstrengths"
    sort={{ rarity: 1 }}
    cacheKey={cacheKey}
  >
    {children}
  </DataProvider>
);

export const usePropStrengthData = () => {
  const context = useContext(PropStrengthDataContext);
  if (context === null) {
    throw new Error(
      "usePropStrengthData must be used within a PropStrengthDataProvider",
    );
  }
  return context;
};
